import React from 'react'
import { Head } from '@inertiajs/react'
import AdminLayout from '../../components/AdminLayout'
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card'
import { Users, FileText, Building2, MapPin, Layers, Activity } from 'lucide-react'

interface Props {
  stats: {
    total_users: number
    total_offers: number
    total_clients: number
    total_providers: number
    total_verticals: number
    total_countries: number
  }
}

function AdminDashboard({ stats }: Props) {
  const statCards = [
    { name: 'Users', value: stats.total_users, icon: Users, color: 'text-blue-600' },
    { name: 'Offers', value: stats.total_offers, icon: FileText, color: 'text-green-600' },
    { name: 'Clients', value: stats.total_clients, icon: Building2, color: 'text-purple-600' },
    { name: 'Providers', value: stats.total_providers, icon: Building2, color: 'text-orange-600' },
    { name: 'Verticals', value: stats.total_verticals, icon: Layers, color: 'text-indigo-600' },
    { name: 'Countries', value: stats.total_countries, icon: MapPin, color: 'text-red-600' },
  ]

  return (
    <>
      <Head title="Admin Dashboard | Mailkit - Resolute" />
      
      <div>
        <div className="mb-8">
          <h2 className="text-2xl font-bold text-gray-900">Overview</h2>
          <p className="text-gray-600 mt-1">Dashboard metrics and key performance indicators</p>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
          {statCards.map((stat) => (
            <Card key={stat.name} className="hover:shadow-lg transition-shadow">
              <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                <CardTitle className="text-lg font-semibold text-gray-800">
                  {stat.name}
                </CardTitle>
                <stat.icon className={`h-6 w-6 ${stat.color}`} />
              </CardHeader>
              <CardContent>
                <div className="text-2xl font-bold">{stat.value}</div>
              </CardContent>
            </Card>
          ))}
        </div>

      </div>
    </>
  )
}

// Set persistent layout
AdminDashboard.layout = page => <AdminLayout>{page}</AdminLayout>

export default AdminDashboard